import { CALLSIGN_LIST } from './constants.js';

export function hashStringToSeed(value) {
    let hash = 1779033703 ^ value.length;
    for (let i = 0; i < value.length; i++) {
        hash = Math.imul(hash ^ value.charCodeAt(i), 3432918353);
        hash = (hash << 13) | (hash >>> 19);
    }
    return hash >>> 0;
}

export function createSeededRandom(seedText) {
    let seed = hashStringToSeed(seedText) || 1;
    return () => {
        seed += 0x6D2B79F5;
        let result = Math.imul(seed ^ (seed >>> 15), 1 | seed);
        result ^= result + Math.imul(result ^ (result >>> 7), 61 | result);
        return ((result ^ (result >>> 14)) >>> 0) / 4294967296;
    };
}

export const random = (min, max, rng = Math.random) => rng() * (max - min) + min;

export const degToRad = (deg) => deg * (Math.PI / 180);

export const radToDeg = (rad) => rad * (180 / Math.PI);

export const formatCallsign = (rng = Math.random) =>
    `${CALLSIGN_LIST[Math.floor(rng() * CALLSIGN_LIST.length)]}${Math.floor(random(1, 999, rng))}`;
